import { render, staticRenderFns } from "./StaffServiceModal.vue?vue&type=template&id=1338a93e&scoped=true"
import script from "./StaffServiceModal.vue?vue&type=script&lang=ts"
export * from "./StaffServiceModal.vue?vue&type=script&lang=ts"
import style0 from "./StaffServiceModal.vue?vue&type=style&index=0&id=1338a93e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1338a93e",
  null
  
)

export default component.exports